module.exports = __webpack_public_path__ + "files/c7a2dd5551e9a6c0f21e70e8d9aa6bc7.png";